var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 6C2 6.54386 2.45614 7 3 7H4V18C4 20.2456 5.75439 22 8 22H16C18.2456 22 20 20.2456 20 18V7H21C21.5439 7 22 6.54386 22 6C22 5.45614 21.5439 5 21 5H20H19H5H4H3C2.45614 5 2 5.45614 2 6ZM8 3C8 3.54386 8.45614 4 9 4H15C15.5439 4 16 3.54386 16 3C16 2.45614 15.5439 2 15 2H9C8.45614 2 8 2.45614 8 3ZM9 17V10C9 9.45614 9.45614 9 10 9C10.5439 9 11 9.45614 11 10V17C11 17.5439 10.5439 18 10 18C9.45614 18 9 17.5439 9 17ZM13 17V10C13 9.45614 13.4561 9 14 9C14.5439 9 15 9.45614 15 10V17C15 17.5439 14.5439 18 14 18C13.4561 18 13 17.5439 13 17Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.39d47d73.svg";
export { ForwardRef as ReactComponent };